export default __webpack_public_path__ + "static/media/NotoSansKR-Thin.e4804399.woff";